import React, { useState } from "react";
import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";

import thumb5 from "../images/thumb_05.jpg";
import thumb6 from "../images/thumb_06.jpg";
import thumb7 from "../images/thumb_07.jpg";
import thumb8 from "../images/thumb_08.jpg";
import thumb9 from "../images/thumb_09.jpg";
import thumb10 from "../images/thumb_10.jpg";
import thumb11 from "../images/thumb_11.jpg";

import img5 from "../images/5.png";
import img6 from "../images/6.png";
import img7 from "../images/7.png";
import img8 from "../images/8.png";
import img9 from "../images/9.png";
import img10 from "../images/10.png";
import img11 from "../images/11.png";

import "./modal.css";

export default function EyeAnatomy() {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("");
    const [showImage, setShowImage] = useState(null);

    const handleShow = (subtitle, imagename) => {
        setTitle(subtitle);
        setShowImage(imagename);
        setShow(true);
    };

    const cards = [
        { title: "Eye Front", thumb: thumb5, image: img5 },
        { title: "Eye 3/4", thumb: thumb6, image: img6 },
        { title: "Eye Profile", thumb: thumb7, image: img7 },
        { title: "Cutaway 1", thumb: thumb8, image: img8 },
        { title: "Cutaway 2", thumb: thumb9, image: img9 },
        { title: "Cutaway 3", thumb: thumb10, image: img10 },
        { title: "Fundus", thumb: thumb11, image: img11 },
    ];

    return (
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Eye Anatomy</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* Reusable Modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    );
}
